module.exports = __webpack_public_path__ + "static/media/02-ft-worth-texas.1401737d.jpg";